const BASE_URL = `${import.meta.env.VITE_BASE_URL}`;
export default BASE_URL;
